import React, { useEffect } from 'react';
import { Form, Input, Button } from 'antd';
import { useCustomers } from './CustomersStore';
import { useForm } from 'antd/es/form/Form';

function Edit() {
    let { updateCustomer, ed } = useCustomers()
    let [form] = useForm();
    useEffect(() => {
        form.setFieldsValue(ed)
    }, [ed])
    return (
        <Form form={form} layout="vertical" onFinish={updateCustomer}>
            <Form.Item name={'id'} hidden>
                <Input />
            </Form.Item>
            <Form.Item label="Familya" name="last_name">
                <Input />
            </Form.Item>
            <Form.Item label="Ismi" name="first_name">
                <Input />
            </Form.Item>
            <Form.Item label="Telefon" name="mobile">
                <Input />
            </Form.Item>
            <Form.Item label="Qarzi" name="balance">
                <Input />
            </Form.Item>
            <Form.Item label="Manzil" name="address">
                <Input />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">Tahrirlash</Button>
            </Form.Item>
        </Form>
    );
}

export default Edit;